'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Reservation = require('@wix/wixrest-utils/dist/openrest-helpers/Reservation');

var _Reservation2 = _interopRequireDefault(_Reservation);

var _CancellationReason = require('../CancellationReason');

var _CancellationReason2 = _interopRequireDefault(_CancellationReason);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ReservationCancellationReason(_ref) {
    var i18n = _ref.i18n,
        reservation = _ref.reservation,
        fontFamily = _ref.fontFamily,
        paddingVertical = _ref.paddingVertical,
        paddingHorizontal = _ref.paddingHorizontal,
        marginTop = _ref.marginTop;

    var _Reservation$getDispl = _Reservation2.default.getDisplayableReservation(reservation),
        cancellationReason = _Reservation$getDispl.cancellationReason;

    return cancellationReason ? _react2.default.createElement(_CancellationReason2.default, {
        reason: cancellationReason,
        i18n: i18n,
        fontFamily: fontFamily,
        paddingVertical: paddingVertical,
        paddingHorizontal: paddingHorizontal,
        marginTop: marginTop
    }) : null;
}

ReservationCancellationReason.displayName = 'ReservationCancellationReason';

ReservationCancellationReason.propTypes = {
    i18n: _propTypes2.default.object,
    reservation: _propTypes2.default.object,
    fontFamily: _propTypes2.default.string,
    paddingVertical: _propTypes2.default.number,
    paddingHorizontal: _propTypes2.default.number,
    marginTop: _propTypes2.default.number
};

exports.default = ReservationCancellationReason;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationCancellationReason.js
// module id = 469
// module chunks = 0